module.exports = __webpack_public_path__ + "media/images/products/products/img04-c8c48ef310e76e40cd8912d16051d41a.jpg";